import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from "../../config";
import { useLanguage } from "../../Context";

export default function Latest() {
  const [items, setItems] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { language } = useLanguage();

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=7&categoryid=0&subcategory=0&limitCount=1&lang=${language}`
    )
      .then((response) => response.json())
      .then((items) => {
        setItems(items);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, [language]);

  // Loader before data is loaded
  if (isLoading) {
    return (
      <div className="max-container-width pt-4 pb-3">
        <div className="d-flex flex-column flex-lg-row bg-body-secondary">
          <div
            className="col-lg-6 bg-body-tertiary"
            style={{ minHeight: "38vh" }}
          />
          <div className="col-lg-6 p-3">
            <div className="placeholder-glow">
              <span
                className="placeholder col-12 mb-3"
                style={{ height: "1.8rem" }}
              ></span>
              <span
                className="placeholder col-6 mb-3"
                style={{ height: "1.8rem" }}
              ></span>
              <span className="placeholder col-9 mb-3"></span>
              <div className="d-flex justify-content-end">
                <a
                  className="btn disabled placeholder me-auto"
                  aria-disabled="true"
                  style={{ backgroundColor: "#024c67", width: "9rem" }}
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // error if data is not fetched
  if (error) {
    return (
      <div className="max-container-width pt-4 pb-3">
        <p className="alert alert-danger" role="alert" dir="ltr">
          Something went wrong: {error.message}
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="max-container-width pt-4 pb-3 primary-text-blue">
        {items.map((content) => (
          <div
            key={content.id}
            className="d-flex flex-column flex-lg-row bg-body-secondary"
          >
            <Link
              to={`/${content.CategoryE}/${content.SubCategory}/${content.id}`}
              className="col-lg-6 latest-heigth"
              style={{ position: "relative" }}
            >
              <img
                src="/img/arrow.png"
                alt=""
                className="icon-links"
                style={{
                  width: "15%",
                  position: "absolute",
                  left: "0",
                  right: "0",
                  top: "0",
                  bottom: "0",
                  margin: "auto",
                }}
              />
              <img
                className="w-100 h-100 object-fit-contain"
                src={
                  content.previewImage ? content.previewImage : content.ImageUrl
                }
                alt=""
                style={{ maxHeight: "25em" }}
              />
            </Link>
            <div className="col-lg-6 p-3">
              <h2
                className="border-end border-5 pe-2"
                id="secondary-border-yellow"
              >
                {content.Title}
              </h2>
              <p className="fw-medium latest-limit-text">{content.ShortDesc}</p>
              <div className="text-start">
                <Link
                  to={`/${content.CategoryE}/${content.SubCategory}/${content.id}`}
                  className="btn primary-bg-blue text-white icon-links mb-3 ms-auto"
                >
                  <img
                    src="/img/arrow-w.png"
                    style={{
                      transform: "rotate(180deg)",
                      width: "1.5em",
                      marginLeft: ".5rem",
                    }}
                    alt=""
                  />
                  مشاهده محتوا
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
